import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { revenueStatsByArticleMainGroup } from "../utils/revenueStatsByArticleMainGroup"
import { revenueYtdStatsByArticleMainGroup } from "../utils/revenueYtdStatsByArticleMainGroup"

export const queryRevenueByArticleMainGroup = {
  async revenueByArticleMainGroup(_parent, args, context, _info) {
    const { admNumber, customerNumber, year, month } = args
    const user = context?.user

    await checkPermissions({
      user,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    if (customerNumber) {
      await validateAccessRightsToCustomer({
        user: user,
        customerNumber: customerNumber,
      })
    }

    const data =
      year > 0
        ? await revenueStatsByArticleMainGroup({
            admNumber,
            customerNumber,
            year,
            month,
          })
        : await revenueYtdStatsByArticleMainGroup({
            admNumber,
            customerNumber,
          })

    return { summary: data?.summary, revenueStats: data?.revenueStats }
  },
}
